import TestInstructionItem from '../TestInstrcutionItem'
import Button from 'components/UI/Button'
import { useNavigate } from 'react-router-dom'

import { enterFullscreen } from '../../../../../helpers/fullscreen'
import ErrorMessageWithExclamation from 'components/UI/ErrorMessageWithExclamation'
import { useDispatch, useSelector } from 'react-redux'
import { selectInstructionError } from 'routing/fetchingfunction/user/user.reducer'
import './style.css'
import { forwardRef, useEffect, useState } from 'react'
import TestProcessWarning from '../TestProcess/TestProcessWarning'
import { toggleFullscreen } from 'routing/fetchingfunction/user/user.action'
import { proctoringErrors } from 'constants'
import { Icon } from 'components/UI'

const ProctoringInstructions = ({
  onSubmit,
  videoRef,
  canvasRef,
  onReady,
  showWarning,
  warningMessage,
  onCancel,
  proctorStatus,
  onReset,
}) => {
  const dispatch = useDispatch()
  const error = useSelector(selectInstructionError)
  const [loading, setLoading] = useState(true)
  const [proctorError, setProctorError] = useState(null)
  const navigate = useNavigate()

  const handleSubmit = () => {
    enterFullscreen().then(() => {
      dispatch(toggleFullscreen(true))
      onSubmit()
    })
  }

  const startProctoring = () => {
    // console.log(
    //   'start proctoring',
    //   videoRef.current,
    //   canvasRef.current,
    //   onReady,
    //   loading,
    //   '=============== start'
    // )
    setProctorError(null)
    if (videoRef.current && canvasRef.current) {
      onReady()
        .then((res) => {
          if (res && res?.screenShare) setLoading(false)
        })
        .catch((err) => {
          console.log('[Error Proctoring]: Failed Proctoring error', err.message)
          onCancel(err.message)
          setLoading(false)
          // setProctorError(err.message ?? 'Proctosring set up error')
        })
    }
  }

  useEffect(() => {
    startProctoring()
  }, [])

  // console.log(error, 'error in TestInstructions')
  const handleGoBack = (e) => {
    e.preventDefault()
    // Just navigate back one page in history without canceling the test

    console.log('first')
    onCancel()
  }

  return (
    <>
      <div className="sticky z-10 pointer-events-none border-2 border-green-600 bg-gray-100 overflow-hidden top-10 -left-0 w-60 h-60 rounded-full flex items-center justify-center -ml-80">
        <video
          ref={videoRef}
          className="object-cover -mx-4  proctoring intruction"
          autoPlay
          style={{ marginTop: '0px', height: '100%', width: '100%' }}
        ></video>
        <canvas
          ref={canvasRef}
          className=" absolute top-0 left-0 z-50  h-full w-full"
          style={{ position: 'absolute', top: 0, left: 0 }}
        />
      </div>

      <div className="max-w-[524px] w-full mx-auto -mt-52 flex flex-col items-center justify-start">
        <div className="mb-6">
          <h3 className="text-2xl md:text-3xl font-semibold mb-2 md:mb-3 text-center pt-4">
            Before You Start: Proctoring Rules{' '}
          </h3>

          <p className="text-center font-medium">
            <Icon
              name="warning-triangle"
              color="#f79009"
              className="w-6 h-6 mr-[6px] inline-block"
            />
            <strong className=""> Environment & Camera Requirements</strong>{' '}
            <span className="mt-2 block">
              {' '}
              Please make sure you meet all requirements below before beginning your test.{' '}
            </span>
          </p>
        </div>

        {(error || proctorError) && (
          <div className="!mb-4 text-error-500">
            <p className="font-bold">Following errors occur</p>
            <ErrorMessageWithExclamation text={error ?? proctorError} />
          </div>
        )}

        <div className="bg-primary-500 p-4 md:p-6 rounded-lg w-full mb-6">
          <ul className="flex flex-col items-start justify-start">
            {[
              {
                value: proctoringErrors.MULTI_FACE_ERROR,
                label: 'Make sure no other people or objects appear in your self-view.',
              },
              {
                value: proctoringErrors.FACE_CENTER_ERROR,
                label: 'Keep your face directed toward the camera throughout the test.',
              },
              {
                value: proctoringErrors.NO_CAMERA_ERROR,
                label: 'Ensure your room is well-lit so your face is clearly visible.',
              },
              {
                value: proctoringErrors.NO_CAMERA_ERROR,
                label: 'Keep your camera on and uncovered at all times.',
              },
              {
                value: proctoringErrors.NO_FACE_ERROR,
                label:
                  'Your face must remain visible, leaving the camera frame will cause the test to fail.',
              },
              {
                value: proctoringErrors.NOISE_ERROR,
                label:
                  'No background noise or talking is allowed during the test, your environment must remain quiet.',
              },
            ].map((i) => (
              <TestInstructionItem type={i.value === proctorStatus ? 'warning' : 'check'}>
                {i.label}
              </TestInstructionItem>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-center mb-3">
            <Icon
              name="warning-triangle"
              color="#f79009"
              className="w-6 h-6 mr-[6px] inline-block"
            />{' '}
            If these rules are not followed, your test may be considered invalid and require further
            review, which may delay the availability of your results.
          </p>
        </div>

        <div className="flex flex-col item-center justify-start w-full font-semibold">
          <Button
            disabled={error || proctorError || (proctorStatus && proctorStatus !== 'N/A')}
            isLoading={loading}
            className="w-full !mb-3"
            onClick={handleSubmit}
          >
            Start
          </Button>

          <Button
            className="bg-white !text-primary-150 border !border-primary-75 p-[10px]"
            onClick={handleGoBack}
          >
            Go Back
          </Button>

          {/* <button className="text-primary-75 p-[10px]" onClick={activeProctor}>
          Start screen Share
        </button> */}
        </div>
      </div>

      <TestProcessWarning open={showWarning} onClose={onReset} warningMessage={warningMessage} />
    </>
  )
}
export default ProctoringInstructions
